export default __webpack_public_path__ + "static/media/cancel-new.540be730.svg";